import React from 'react';
import ReactToPrint from 'react-to-print';
import { Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Typography,} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Print from '@material-ui/icons/Print';
import { format } from 'date-fns';
import { inject, observer } from 'mobx-react';
import ReportHeader from '../share/ReportHeader';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingBottom: theme.spacing.unit * 2,
    margin: theme.spacing.unit * 2,
  },
  rootNoRegs: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  paperContribuinte: {
    width: '60%'
  },
  button: {
    margin: theme.spacing.unit,
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
  direita: {
    textAlign: 'right',
    width: '50%',
  },
  centro: {
    textAlign: 'center',
  },
  div: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    textAlign: 'center',
  },
  typography: {
    ...theme.mixins.gutters(),
    paddingBottom: theme.spacing.unit * 2,
    textAlign: 'center',
  },
  fontReport: {
    fontSize: 9
  },
  fontContribuinte: {
    textAlign: 'left',
    fontSize: 11,
    color: 'black',
    marginTop: theme.spacing.unit * 2,
    fontWeight: 'bold',
  },
  fontNomeSecondary: {
    textAlign: 'left',
    fontSize: 9,
    color: 'grey',
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
  },
  fontCpfSecondary: {
    textAlign: 'left',
    fontSize: 9,
    color: 'grey',
    marginTop: theme.spacing.unit,
  },
  fontNome: {
    textAlign: 'left',
    fontSize: 11,
    color: 'black',
    marginBottom: theme.spacing.unit,
    marginLeft: theme.spacing.unit * 2,
  },
  fontCpf: {
    textAlign: 'left',
    fontSize: 11,
    color: 'black',
    marginBottom: theme.spacing.unit,
  },
  fontNomeComp: {
    textAlign: 'left',
    fontSize: 11,
    color: 'black',
    paddingTop: theme.spacing.unit * 2,
    marginLeft: theme.spacing.unit,
  },
  divHalf: {
    width: '50%',
    display: 'inline-block',
  },
  paperInfoComp: {
    marginTop: theme.spacing.unit * 1.5,
  },
  paperInfoCompSemTop: {
    marginTop: theme.spacing.unit * 0,
  },
  paperInfoCompComTop: {
    marginTop: theme.spacing.unit * 10,
  },
  fontDespesaMedica: {
    marginTop: theme.spacing.unit * 1,
    fontWeight: 'bold',
    marginLeft: theme.spacing.unit,
    fontSize: 11,
  },
  reportHeader: {
    background: '#b9b9b9',
    height: '35px'
  },
  width100: {
    width: '100%',
    border: 'none'
  },
  width90: {
    width: '90%',
    border: 'none'
  },
  paperFontSecondary: {
    fontSize: 9,
    color: 'grey',
    marginTop: theme.spacing.unit,
    marginLeft: theme.spacing.unit,
  },
});

@inject('usuarioStore')
@observer

class ComponentToPrint extends React.Component {
  render () {
    const { classes, reembolsos, mesAno } = this.props;
    return (
      <Paper className={classes.root} elevation={0}>
        <ReportHeader titulo={'Relatório de Reembolsos - Mês de Referência: ' + mesAno} />
        {reembolsos !== undefined && reembolsos.length !== 0
            ? <Table padding={'default'}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.fontReport} style={{width: '250px'}}>Beneficiario</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '25px'}}>Rubrica</TableCell>
                  <TableCell className={classes.fontReport} style={{width: '25px'}}>Valor Reembolso</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reembolsos.map((reembolso, idx) => {
                    return (
                      <TableRow key={idx}>
                        {reembolso.codigo === 'TOTAL' ? <TableCell className={classes.fontReport}>{reembolso.codigo}</TableCell> : <TableCell className={classes.fontReport}>{reembolso.codigo + ' - ' + reembolso.nome}</TableCell>}
                        {reembolso.codRubrica !== 0 ? <TableCell className={classes.fontReport}>{reembolso.codRubrica + ' - ' + reembolso.desRubrica}</TableCell> : <TableCell className={classes.fontReport}>{'  '}</TableCell>}
                        <TableCell className={classes.fontReport}>{new Intl.NumberFormat('pt-BR', {style: 'currency', currency: 'BRL'}).format(reembolso.valReembolso)}</TableCell>
                      </TableRow>
                    );
                })
                }
              </TableBody>
            </Table>
          : <Paper className={classes.rootNoRegs} elevation={1}>
            <Typography className={classes.centro} component='p'>
              Não foram encontrados registros de Reembolso para este filtro.
            </Typography>
          </Paper>}
      </Paper>
    );
  }
}

class PrintComponentRelatorioReembolso extends React.Component {
  render () {
    const { classes, reembolsos, nomeTitular, mesAno } = this.props;
    return (
      <div>
        <ReactToPrint
          trigger={() =>
            <div className={classes.div}>
              <Button
                variant='contained'
                color='primary'
                className={classes.button}
                href='#'>
                <Print className={classes.icon} /> Imprimir / Salvar
              </Button>
            </div>}
          content={() => this.componentRef}
        />
        <ComponentToPrint
          ref={el => (this.componentRef = el)}
          nomeTitular={nomeTitular}
          mesAno={mesAno}
          reembolsos={reembolsos}
          classes={classes} />
      </div>
    );
  }
}
export default withStyles(styles)(PrintComponentRelatorioReembolso);
